import { render, staticRenderFns } from "./PasswordModal.vue?vue&type=template&id=045862c8&"
import script from "./PasswordModal.vue?vue&type=script&lang=js&"
export * from "./PasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports